import { render, staticRenderFns } from "./TransferenciasJugadoresSelector.vue?vue&type=template&id=0a7a3e0d&scoped=true&"
import script from "./TransferenciasJugadoresSelector.vue?vue&type=script&lang=js&"
export * from "./TransferenciasJugadoresSelector.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciasJugadoresSelector.vue?vue&type=style&index=0&id=0a7a3e0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7a3e0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VTab,
  VTabs,
  VToolbar,
})
